import { render, staticRenderFns } from "./Form1.vue?vue&type=template&id=65ef98c8&scoped=true&"
import script from "./Form1.vue?vue&type=script&lang=js&"
export * from "./Form1.vue?vue&type=script&lang=js&"
import style0 from "./Form1.vue?vue&type=style&index=0&id=65ef98c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ef98c8",
  null
  
)

export default component.exports